// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + {"34223":"commons","36209":"ui","72213":"sbanken","91336":"eiendom"}[chunkId] + "." + {"34223":"18c273f18b4130b1fe20","36209":"3e8975b7571e09bba0d2","72213":"7280b5fc69799260ccec","91336":"e6ab82f4b2657bfe473f"}[chunkId] + ".css";
};